/**
 * LPS Scroll Banner – scroll-driven frame animation.
 * Finds all [data-lps-scroll-banner] and inits each with GSAP ScrollTrigger.
 * Requires gsap.min.js and ScrollTrigger.min.js to load before this script.
 */
(function() {
  var MOBILE_BREAKPOINT = 750;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function waitForGsap(callback) {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      callback();
      return;
    }
    setTimeout(function() { waitForGsap(callback); }, 50);
  }

  function initSection(wrapper) {
    if (wrapper.hasAttribute('data-lps-scroll-banner-inited')) return;
    wrapper.setAttribute('data-lps-scroll-banner-inited', '1');
    var canvas = wrapper.querySelector('canvas');
    if (!canvas) return;

    var isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
    var frameRoot = isMobile && wrapper.getAttribute('data-frame-root-mobile')
      ? wrapper.getAttribute('data-frame-root-mobile')
      : wrapper.getAttribute('data-frame-root');
    var frameCount = parseInt(
      isMobile && wrapper.getAttribute('data-frame-count-mobile')
        ? wrapper.getAttribute('data-frame-count-mobile')
        : wrapper.getAttribute('data-frame-count'),
      10
    );
    if (!frameRoot || frameCount < 1) return;

    var pin = wrapper.getAttribute('data-pin') === 'true';
    var ctx = canvas.getContext('2d');
    var images = [];
    var anim = { frame: 0 };

    for (var i = 0; i < frameCount; i++) {
      var img = new Image();
      img.src = frameRoot + String(i).padStart(3, '0') + '.jpg';
      images.push(img);
    }

    function setCanvasSize(naturalWidth, naturalHeight) {
      canvas.width = naturalWidth;
      canvas.height = naturalHeight;
    }

    function render() {
      if (!canvas.width || !canvas.height) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var img = images[anim.frame];
      if (img && img.complete && img.naturalWidth) {
        ctx.drawImage(img, 0, 0);
      }
    }

    images[0].onload = function() {
      var w = this.naturalWidth;
      var h = this.naturalHeight;
      if (w && h) {
        setCanvasSize(w, h);
      } else {
        var fallbackW = parseInt(isMobile && wrapper.getAttribute('data-width-mobile') ? wrapper.getAttribute('data-width-mobile') : wrapper.getAttribute('data-width'), 10) || 1920;
        var fallbackH = parseInt(isMobile && wrapper.getAttribute('data-height-mobile') ? wrapper.getAttribute('data-height-mobile') : wrapper.getAttribute('data-height'), 10) || 1080;
        setCanvasSize(fallbackW, fallbackH);
      }
      render();
      if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
    };

    gsap.to(anim, {
      frame: frameCount - 1,
      snap: { frame: 1 },
      ease: 'none',
      scrollTrigger: {
        trigger: wrapper,
        start: pin ? 'top top' : 'top bottom',
        end: pin ? '+=700' : 'bottom top',
        scrub: 0.5,
        invalidateOnRefresh: true
      },
      onUpdate: render
    });
  }

  ready(function() {
    waitForGsap(function() {
      ScrollTrigger.register(gsap);
      var sections = document.querySelectorAll('[data-lps-scroll-banner]');
      for (var i = 0; i < sections.length; i++) initSection(sections[i]);
    });
  });
})();
